
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.314 4.686C24.292 1.664 20.274 0 16 0S7.708 1.664 4.686 4.686C1.664 7.708 0 11.726 0 16s1.664 8.292 4.686 11.314C7.708 30.336 11.726 32 16 32s8.292-1.664 11.314-4.686C30.336 24.292 32 20.274 32 16s-1.664-8.292-4.686-11.314zM28 16c0 2.588-.824 4.987-2.222 6.949L9.051 6.222A11.93 11.93 0 0116 4c6.617 0 12 5.383 12 12zM4 16c0-2.588.824-4.987 2.222-6.949l16.727 16.727A11.93 11.93 0 0116 28C9.383 28 4 22.617 4 16z"}})])
          )
        }
      }
    